var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import Popup from 'reactjs-popup';
import { Button, CardImage, Icon, Title } from '@gerdau/hefesto';
import './InformationPanel.styles.scss';
var EMappedInputEventCodes;
(function (EMappedInputEventCodes) {
    EMappedInputEventCodes["ARROW_DOWN"] = "ArrowDown";
    EMappedInputEventCodes["ARROW_UP"] = "ArrowUp";
    EMappedInputEventCodes["ENTER"] = "Enter";
    EMappedInputEventCodes["ESC"] = "Escape";
})(EMappedInputEventCodes || (EMappedInputEventCodes = {}));
var InformationPanel = function (_a) {
    var trigger = _a.trigger, position = _a.position, title = _a.title, panelOptions = _a.panelOptions, handleOpen = _a.handleOpen, _b = _a.classNamePopup, classNamePopup = _b === void 0 ? '' : _b, _c = _a.type, type = _c === void 0 ? 'list' : _c, text = _a.text, _d = _a.panelWidth, panelWidth = _d === void 0 ? '16.875rem' : _d, actionOne = _a.actionOne, handleActionOne = _a.handleActionOne, actionTwo = _a.actionTwo, handleActionTwo = _a.handleActionTwo, imgSrc = _a.imgSrc, _e = _a.imgObjectFit, imgObjectFit = _e === void 0 ? 'cover' : _e, _f = _a.imgObjectPosition, imgObjectPosition = _f === void 0 ? 'center' : _f;
    var optionsRef = useRef(null);
    var _g = useState(false), isOpen = _g[0], setIsOpen = _g[1];
    var _h = useState(-1), optionHoveredIdx = _h[0], setOptionHoveredIdx = _h[1];
    var updateCustomSelectHovered = function (newIndex) {
        var _a, _b;
        var prevOption = (_a = optionsRef.current) === null || _a === void 0 ? void 0 : _a.children[optionHoveredIdx];
        var option = (_b = optionsRef.current) === null || _b === void 0 ? void 0 : _b.children[newIndex];
        if (prevOption) {
            prevOption.classList.remove('hover');
        }
        if (option) {
            option.classList.add('hover');
        }
        setOptionHoveredIdx(newIndex);
    };
    var handleOnKeyDown = function (event) {
        if (!panelOptions ||
            !Object.values(EMappedInputEventCodes).find(function (key) { return key === event.key; })) {
            return;
        }
        switch (event.key) {
            case EMappedInputEventCodes.ARROW_DOWN: {
                if (optionHoveredIdx < panelOptions.length - 1) {
                    updateCustomSelectHovered(optionHoveredIdx + 1);
                }
                return;
            }
            case EMappedInputEventCodes.ARROW_UP: {
                if (optionHoveredIdx === -1) {
                    updateCustomSelectHovered(panelOptions.length - 1);
                }
                else if (optionHoveredIdx > 0) {
                    updateCustomSelectHovered(optionHoveredIdx - 1);
                }
                return;
            }
            case EMappedInputEventCodes.ENTER: {
                var option = panelOptions[optionHoveredIdx];
                if (option) {
                    handlePanelClose();
                    !!(option === null || option === void 0 ? void 0 : option.handleOnClick) && (option === null || option === void 0 ? void 0 : option.handleOnClick());
                }
                return;
            }
            default: {
                return;
            }
        }
    };
    var handlePanelOpen = function () {
        var _a;
        (_a = optionsRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        setIsOpen(true);
        !!handleOpen && handleOpen();
    };
    var handlePanelClose = function () {
        setOptionHoveredIdx(-1);
        setIsOpen(false);
        !!handleOpen && handleOpen();
    };
    var getOptionClassName = function (option) {
        var classList = ['hefesto-information-panel__list__item'];
        if (option.disabled) {
            classList.push('hefesto-information-panel__list__item--disabled');
        }
        if (option.variant) {
            classList.push("hefesto-information-panel__list__item--".concat(option.variant));
        }
        return classList.join(' ');
    };
    return (_jsx("div", __assign({ className: "hefesto-information-panel" }, { children: _jsxs(Popup, __assign({ className: classNamePopup, arrow: true, open: isOpen, arrowStyle: {
                width: '1rem',
                height: '0.5rem',
                color: 'var(--secondary-color-03-50)',
            }, closeOnDocumentClick: true, closeOnEscape: true, mouseEnterDelay: 100, mouseLeaveDelay: 100, position: position, repositionOnResize: true, trigger: trigger, offsetX: 8, offsetY: 8, contentStyle: {
                backgroundColor: 'var(--secondary-color-03-50)',
                width: panelWidth,
                height: 'auto',
                left: '0',
                boxShadow: '0 0 var(--spacing-size-xxxl) var(--support-color-generic-shadow-alpha-35)',
                borderRadius: 'var(--border-radius-md)',
            }, onOpen: handlePanelOpen, onClose: handlePanelClose }, { children: [type === 'image' && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "hefesto-information-panel__header--image" }, { children: _jsx("div", __assign({ className: "icon-wrapper", onClick: handlePanelClose }, { children: _jsx(Icon, { option: "X" }) })) })), _jsx(CardImage, { src: imgSrc, objectFit: imgObjectFit, objectPosition: imgObjectPosition })] })), _jsxs("div", __assign({ className: "hefesto-information-panel__header ".concat(type, " ").concat(title ? '' : 'empty') }, { children: [title && _jsx(Title, __assign({ level: 5 }, { children: title })), type === 'text' && (_jsx("div", __assign({ className: "icon-wrapper", onClick: handlePanelClose }, { children: _jsx(Icon, { option: "X" }) })))] })), _jsxs("div", __assign({ className: "hefesto-information-panel__content ".concat(type, " ").concat(title ? '' : 'empty'), onKeyDown: handleOnKeyDown, tabIndex: 0, "data-testid": "hefesto-panel-content" }, { children: [(type === 'text' || type === 'image') && (_jsx("p", __assign({ role: "contentinfo" }, { children: text }))), _jsx("ul", __assign({ className: "hefesto-information-panel__list", ref: optionsRef }, { children: panelOptions === null || panelOptions === void 0 ? void 0 : panelOptions.map(function (option, idx) { return (_jsxs("li", __assign({ className: getOptionClassName(option), onClick: function () {
                                    !!option.handleOnClick && option.handleOnClick();
                                    handlePanelClose();
                                } }, { children: [_jsx("i", { children: option.icon }), _jsx("span", { children: option.text })] }), idx)); }) }))] })), type === 'image' && (_jsxs("div", __assign({ className: "hefesto-information-panel__footer" }, { children: [actionOne && (_jsx(Button, __assign({ name: "actionOne", variant: "tertiary", onClick: function () { return !!handleActionOne && handleActionOne(); } }, { children: actionOne }))), actionTwo && (_jsx(Button, __assign({ name: "actionTwo", variant: "tertiary", onClick: function () { return !!handleActionTwo && handleActionTwo(); } }, { children: actionTwo })))] })))] })) })));
};
export default InformationPanel;
